import React from 'react';
import { searchBarStyles } from '../styles/sharedStyles';

const SearchBar = ({
  value,
  onChange,
  placeholder = 'Search...',
  onSearch,
  style = {},
}) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const inputStyle = {
    ...searchBarStyles.input,
    ...(isFocused ? searchBarStyles.inputFocus : {}),
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch(value);
    }
  };

  return (
    <div style={{ ...searchBarStyles.container, ...style }}>
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onKeyPress={handleKeyPress}
        style={inputStyle}
      />
      <span style={searchBarStyles.icon}>🔍</span>
    </div>
  );
};

export default SearchBar;
